import { render, staticRenderFns } from "./FaltantesFactura.vue?vue&type=template&id=36ac26ed"
import script from "./FaltantesFactura.vue?vue&type=script&lang=js"
export * from "./FaltantesFactura.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports